import { render } from "./CreateUpdate.vue?vue&type=template&id=d21108c8&scoped=true"
import script from "./CreateUpdate.vue?vue&type=script&lang=js"
export * from "./CreateUpdate.vue?vue&type=script&lang=js"

import "./CreateUpdate.vue?vue&type=style&index=0&id=d21108c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d21108c8"]])

export default __exports__